import { ResetPasswordPage } from '@/containers';

export const ResetPassword = () => {
  return <ResetPasswordPage />;
};
